import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/leftArrowFilled.svg'
import _imports_3 from '@/assets/rightArrowFilled.svg'
import _imports_4 from '@/assets/addImage.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1913b982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "headerText" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
], -1))
const _hoisted_12 = { class: "mt-5 bg-white border border-lightgrey relative rounded" }
const _hoisted_13 = { class: "px-5 pb-5 pt-5 w-full h-full" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "group-buttons"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "arrow left-0"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "arrow right-0"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "arrow left-0"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "arrow right-0"
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progressbarB rounded h-1" }, null, -1))
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "py-2 noScrollbar tabStructure1 overflow-y-auto" }
const _hoisted_30 = { class: "formcontainer flex flex-col" }
const _hoisted_31 = { class: "row flex flex-row w-full" }
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Name", -1))
const _hoisted_34 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_35 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_36 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_37 = {
  key: 2,
  class: "invalid-feedback text-xs"
}
const _hoisted_38 = { class: "w-6/12 leftspacing" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Category", -1))
const _hoisted_40 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_41 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_42 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-error text-xs" }, "Character Limit is exceeded", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "w-full upperspacing" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Description", -1))
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_51 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_52 = { class: "col-md-6 w-6/12" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Model", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select one", -1))
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_57 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_58 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Add (URL / IP Address / Domain Name)", -1))
const _hoisted_60 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_61 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_62 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_63 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_64 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "This url already exists", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "row flex w-full upperspacing" }
const _hoisted_68 = { class: "col-md-6 w-full" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Vendor", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "No Vendors Found", -1))
const _hoisted_71 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_72 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_73 = { class: "row w-full upperspacing" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Logo", -1))
const _hoisted_75 = { class: "flex justify-center" }
const _hoisted_76 = { class: "flex justify-center" }
const _hoisted_77 = ["htmlFor"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "w-20 h-20 cursor-pointer"
}, null, -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = ["htmlFor"]
const _hoisted_81 = ["id"]
const _hoisted_82 = { class: "flex justify-center items-center mt-2" }
const _hoisted_83 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_84 = { class: "text-xs font-bold" }
const _hoisted_85 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_86 = {
  key: 1,
  class: "border w-full rounded py-2 border-lightgrey"
}
const _hoisted_87 = ["htmlFor"]
const _hoisted_88 = ["src"]
const _hoisted_89 = ["htmlFor"]
const _hoisted_90 = ["id"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-center cursor-pointer" }, "Click on the icon/logo for uploading a file", -1))
const _hoisted_92 = { class: "flex justify-center items-center mt-2" }
const _hoisted_93 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_94 = { class: "text-xs font-bold" }
const _hoisted_95 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_96 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_97 = {
  key: 1,
  class: "pt-3 noScrollbar tabStructure1 overflow-y-auto"
}
const _hoisted_98 = { class: "tableCornerRadius" }
const _hoisted_99 = { class: "table-container noScrollbar" }
const _hoisted_100 = { class: "header cursor-pointer w-4" }
const _hoisted_101 = { class: "flex items-center w-4 mx-2" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = {
  key: 0,
  class: "pl-5"
}
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_108 = ["onUpdate:modelValue"]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_110 = ["value"]
const _hoisted_111 = ["onUpdate:modelValue"]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_113 = ["value"]
const _hoisted_114 = ["onUpdate:modelValue"]
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "cursor-pointer rowHeight" }
const _hoisted_117 = ["colspan"]
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
], -1))
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_121 = ["value"]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { key: 2 }
const _hoisted_126 = { class: "table-ellipsis" }
const _hoisted_127 = ["onMousemove"]
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = {
  key: 2,
  class: "pt-3 noScrollbar tabStructure1 overflow-y-auto"
}
const _hoisted_131 = { class: "tableCornerRadius" }
const _hoisted_132 = { class: "table-container noScrollbar" }
const _hoisted_133 = { class: "header cursor-pointer w-4" }
const _hoisted_134 = { class: "flex items-center w-4 mx-2" }
const _hoisted_135 = ["disabled"]
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 0,
  class: "pl-5"
}
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_141 = ["onUpdate:modelValue"]
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_143 = ["value"]
const _hoisted_144 = ["onUpdate:modelValue"]
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select", -1))
const _hoisted_146 = ["value"]
const _hoisted_147 = ["onUpdate:modelValue"]
const _hoisted_148 = { key: 0 }
const _hoisted_149 = { class: "cursor-pointer rowHeight" }
const _hoisted_150 = ["colspan"]
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
], -1))
const _hoisted_152 = [
  _hoisted_151
]
const _hoisted_153 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_154 = ["value"]
const _hoisted_155 = { key: 0 }
const _hoisted_156 = { key: 1 }
const _hoisted_157 = { key: 2 }
const _hoisted_158 = { class: "table-ellipsis" }
const _hoisted_159 = ["onMousemove"]
const _hoisted_160 = { key: 0 }
const _hoisted_161 = { key: 0 }
const _hoisted_162 = {
  key: 0,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_163 = { class: "buttonposition flex justify-end items-center px-5" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = ["disabled"]
const _hoisted_166 = {
  key: 1,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_167 = { class: "buttonposition flex justify-end items-center px-5" }
const _hoisted_168 = ["disabled"]
const _hoisted_169 = ["disabled"]
const _hoisted_170 = {
  key: 2,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_171 = { class: "buttonposition flex justify-end items-center px-5" }
const _hoisted_172 = ["disabled"]
const _hoisted_173 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        (_ctx.mainSystem != undefined || _ctx.mainSystem != null)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.mainSystem.name), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_5, "System"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.selectedTabIndex == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["flex", _ctx.activeControlsListDisplay.length == 0 ? 'btndisabled pointer-events-none':'filterButton']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtersOpen()))
            }, [
              (_ctx.activeControlsListDisplay.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8)),
              _createTextVNode(" Filters ")
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["flex", _ctx.allControlsListDisplay.length == 0 ? 'btndisabled pointer-events-none':'filterButton']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filtersOpen()))
            }, [
              (_ctx.allControlsListDisplay.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : (_openBlock(), _createElementBlock("img", _hoisted_10)),
              _createTextVNode(" Filters ")
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.screenReduced)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.isSmallScreen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute left-0 top-5 cursor-pointer", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === 0 || _ctx.currentGroupIndex === 0) && _ctx.isSmallScreen }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollTabs('left')))
                    }, _hoisted_17, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute right-0 top-5 cursor-pointer", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === _ctx.carouselHead.length - 1 || _ctx.currentGroupIndex >= _ctx.totalGroups - 1) && _ctx.isSmallScreen }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollTabs('right')))
                    }, _hoisted_19, 2)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute left-0 top-5 cursor-pointer", { 'disabled pointer-events-none': !_ctx.canScrollLeft && !_ctx.isSmallScreen }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollTabs('left')))
                    }, _hoisted_22, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute right-0 top-5 cursor-pointer", { 'disabled pointer-events-none': !_ctx.canScrollRight && !_ctx.isSmallScreen }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollTabs('right')))
                    }, _hoisted_24, 2)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "flex flex-row borderBottom cursor-pointer tab-container",
            ref: "tabContainer",
            onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["pb-1", _ctx.selectedTabIndex == tab.id ? 'adjust header text-sm font-semibold selectedTabText':'text-sm text-disabledgrey']),
                key: index,
                onClick: ($event: any) => (_ctx.toggleTabs(tab))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    ref_for: true,
                    ref: "actualIndex",
                    class: "cursor-pointer"
                  }, _toDisplayString(tab.displayName), 513),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ progress: _ctx.selectedTabIndex === tab.id }, "h-1 p-0.75 relative rounded"])
                  }, null, 2)
                ])
              ], 10, _hoisted_25))
            }), 128))
          ], 544)
        ]),
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          (_ctx.selectedTabIndex == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': (_ctx.v$.mainSystem.systemName.$error || _ctx.checkSystemName)
                                        }]),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mainSystem.systemName) = $event)),
                          placeholder: "System Name",
                          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.mainSystem.systemName.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.mainSystem.systemName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.mainSystem.systemName.$error || _ctx.checkSystemName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              (_ctx.v$.mainSystem.systemName.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Required"))
                                : (_ctx.v$.mainSystem.systemName.required && _ctx.v$.mainSystem.systemName.restrictNames50.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Charcter Limit is exceeded"))
                                  : (_ctx.checkSystemName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, "System Name already exists."))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.mainSystem.systemCategory,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mainSystem.systemCategory) = $event)),
                          modelModifiers: { trim: true },
                          options: _ctx.systemCategoryDisplay,
                          onSearchChange: _ctx.asyncSystemCategoryDataFind,
                          onSelect: _ctx.checkCategoryLength,
                          multiple: false,
                          searchable: true,
                          "hide-selected": true,
                          "open-direction": "bottom",
                          "close-on-select": true,
                          "clear-on-select": true,
                          hideArrow: false,
                          placeholder: "System Category",
                          deselectLabel: "",
                          showNoOptions: false,
                          selectLabel: "",
                          class: _normalizeClass(["custom-multiselect userSelect", {
                                            'is-invalid': _ctx.v$.mainSystem.systemCategory.$error || _ctx.displayCategoryLengthErrorMessage,
                                            'has-options': _ctx.systemCategoryDisplay && _ctx.systemCategoryDisplay.length > 0,
                                            'no-options': !_ctx.systemCategoryDisplay.length &&  _ctx.searchValue !== '',
                                        }])
                        }, null, 8, ["modelValue", "options", "onSearchChange", "onSelect", "class"]),
                        (_ctx.v$.mainSystem.systemCategory.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_ctx.v$.mainSystem.systemCategory.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Required"))
                                : (_ctx.v$.mainSystem.systemCategory.required && _ctx.v$.mainSystem.systemCategory.restrictNames50.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Character Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_ctx.displayCategoryLengthErrorMessage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "text",
                        class: _normalizeClass(["inputboxstyling", {
                                        'is-invalid': (_ctx.v$.mainSystem.systemDescription.$error)
                                    }]),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mainSystem.systemDescription) = $event)),
                        placeholder: "Description",
                        rows: "3",
                        onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.mainSystem.systemDescription.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.mainSystem.systemDescription,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.mainSystem.systemDescription.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            (_ctx.v$.mainSystem.systemDescription.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                              : (_ctx.v$.mainSystem.systemDescription.required && _ctx.v$.mainSystem.systemDescription.restrictCharacters.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.mainSystem.hostingType) = $event)),
                          class: _normalizeClass({
                                            'is-invalid': _ctx.v$.mainSystem.hostingType.$error,
                                            'inputboxstylingForSelectAtPopup': _ctx.mainSystem.hostingType == '',
                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.mainSystem.hostingType != ''
                                        })
                        }, [
                          _hoisted_54,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemModels, (name) => {
                            return (_openBlock(), _createElementBlock("option", {
                              class: "optionColors",
                              key: name,
                              value: name
                            }, _toDisplayString(name), 9, _hoisted_55))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, _ctx.mainSystem.hostingType]
                        ]),
                        (_ctx.v$.mainSystem.hostingType.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              (_ctx.v$.mainSystem.hostingType.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': (_ctx.v$.mainSystem.url.$error||_ctx.checkwebsiteDomain)
                                        }]),
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mainSystem.url) = $event)),
                          placeholder: "Url",
                          onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.mainSystem.url.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.mainSystem.url,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.mainSystem.url.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              (_ctx.v$.mainSystem.url.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Required"))
                                : (_ctx.v$.mainSystem.url.required && _ctx.v$.mainSystem.url.restrictCharacters100.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, "Charcter Limit is exceeded"))
                                  : (_ctx.v$.mainSystem.url.required &&  _ctx.v$.mainSystem.url.websiteValidateWithIp.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, "Invalid Website"))
                                    : _createCommentVNode("", true)
                            ]))
                          : (_ctx.checkwebsiteDomain)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_66))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.mainSystem.vendor,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mainSystem.vendor) = $event)),
                          options: _ctx.vendorDisplayList,
                          searchable: true,
                          onSearchChange: _ctx.asyncFindVendor,
                          "close-on-select": true,
                          "show-labels": false,
                          "hide-selected": true,
                          placeholder: "Vendor",
                          "open-direction": "bottom",
                          multiple: false,
                          showNoOptions: false,
                          "clear-on-select": true,
                          label: "label",
                          "track-by": "value",
                          hideArrow: false,
                          class: _normalizeClass(["custom-multiselect userSelect", {
                                            'is-invalidmultiselect': _ctx.v$.mainSystem.vendor.$error,
                                            'has-options': _ctx.vendorDisplayList && _ctx.vendorDisplayList.length > 0,
                                            'no-options': !_ctx.vendorDisplayList.length &&  _ctx.searchValue !== '',
                                        }])
                        }, {
                          noResult: _withCtx(() => [
                            _hoisted_70
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onSearchChange", "class"]),
                        (_ctx.v$.mainSystem.vendor.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              (_ctx.v$.mainSystem.vendor.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      (_ctx.mainSystem.imageUrl == '' && !_ctx.mainSystem._id)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([{'is-invalid borderRed': _ctx.v$.fileName.$error,}, "border w-full rounded py-2 border-lightgrey"])
                          }, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_76, [
                                  _createElementVNode("label", {
                                    htmlFor: _ctx.mainSystem,
                                    class: "mt-2"
                                  }, _hoisted_79, 8, _hoisted_77),
                                  _createElementVNode("label", { htmlFor: _ctx.mainSystem }, [
                                    (_openBlock(), _createElementBlock("input", {
                                      type: "file",
                                      id: _ctx.mainSystem,
                                      style: {"display":"none"},
                                      ref: "fileInput",
                                      onChange: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.imageCheckFile('fileInput','add')), ["stop"])),
                                      key: _ctx.fileInputKey
                                    }, null, 40, _hoisted_81))
                                  ], 8, _hoisted_80)
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  (_ctx.fileName!='')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                        _createTextVNode("Selected File : "),
                                        _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.fileName), 1)
                                      ]))
                                    : (_ctx.fileName == '')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString('Click on the icon for uploading a file')))
                                      : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ], 2))
                        : (_ctx.mainSystem._id && _ctx.mainSystem.imageUrl !='')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", {
                                  htmlFor: _ctx.mainSystem,
                                  class: "mt-2 flex justify-center p-2 items-center"
                                }, [
                                  _createElementVNode("img", {
                                    src: _ctx.mainSystem.imageUrl,
                                    alt: "",
                                    class: "w-20 h-20 cursor-pointer"
                                  }, null, 8, _hoisted_88)
                                ], 8, _hoisted_87),
                                _createElementVNode("label", {
                                  htmlFor: _ctx.mainSystem,
                                  onChange: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.imageCheckFile('fileInput','edit')), ["stop"]))
                                }, [
                                  (_openBlock(), _createElementBlock("input", {
                                    type: "file",
                                    id: _ctx.mainSystem,
                                    style: {"display":"none"},
                                    ref: "fileInput",
                                    key: _ctx.fileInputKey
                                  }, null, 8, _hoisted_90)),
                                  _hoisted_91
                                ], 40, _hoisted_89)
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                (_ctx.fileName!='')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                      _createTextVNode("Selected File : "),
                                      _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.fileName), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      (_ctx.v$.fileName.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            (_ctx.v$.fileName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedTabIndex == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("th", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectAllOptionActiveControls) = $event)),
                              class: "checkbox cursor-pointer",
                              disabled: _ctx.allControlsList.length == 0,
                              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectAllActiveControls($event)))
                            }, null, 40, _hoisted_102), [
                              [_vModelCheckbox, _ctx.selectAllOptionActiveControls]
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (column) => {
                          return (_openBlock(), _createElementBlock("th", {
                            scope: "col",
                            onClick: ($event: any) => (_ctx.sort(column)),
                            class: _normalizeClass([_ctx.getHeaderProperties0('width',column), "bg-white capitalize"]),
                            key: column
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties0('widthInner',column)])
                            }, [
                              (column == 'controlPriority')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString('Priority')))
                                : (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.getHeaderProperties0('name',column)), 1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                              }, null, 2)
                            ], 2)
                          ], 10, _hoisted_103))
                        }), 128)),
                        (_ctx.showFilters)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_106, [
                              _hoisted_107,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (name, index) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  class: "bg-white",
                                  key: index
                                }, [
                                  (name == 'controlPriority')
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                      }, [
                                        _hoisted_109,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: pair.value,
                                            value: pair.value
                                          }, _toDisplayString(pair.key), 9, _hoisted_110))
                                        }), 128))
                                      ], 10, _hoisted_108)), [
                                        [_vModelSelect, _ctx.allFilters[name]]
                                      ])
                                    : (name == 'controlFrequency')
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 1,
                                          class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                        }, [
                                          _hoisted_112,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: pair,
                                              value: pair.value
                                            }, _toDisplayString(pair.key), 9, _hoisted_113))
                                          }), 128))
                                        ], 10, _hoisted_111)), [
                                          [_vModelSelect, _ctx.allFilters[name]]
                                        ])
                                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 2,
                                          type: "text",
                                          class: "searchForInputBoxStyling filter-font-size",
                                          placeholder: "Search",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                        }, null, 8, _hoisted_114)), [
                                          [_vModelText, _ctx.allFilters[name]]
                                        ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.sortedDataActiveControls.length == 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_115, [
                            _createElementVNode("tr", _hoisted_116, [
                              _createElementVNode("td", {
                                class: "relative h-10",
                                colspan: _ctx.activeControlHeaders.length+1
                              }, _hoisted_119, 8, _hoisted_117)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_120, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataActiveControls, (dataObj, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                class: "cursor-pointer rowHeight"
                              }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "checkbox mx-2",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.checkedActiveControls) = $event)),
                                    onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changedActiveControlInput())),
                                    value: dataObj._id
                                  }, null, 40, _hoisted_121), [
                                    [_vModelCheckbox, _ctx.checkedActiveControls]
                                  ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControlHeaders, (column) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    scope: "col",
                                    onClick: ($event: any) => (_ctx.showControlDetailsPopup(dataObj)),
                                    onMouseout: _cache[22] || (_cache[22] = ($event: any) => (_ctx.doFalse())),
                                    key: column
                                  }, [
                                    (column == 'controlFrequency')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.getFrequencyValue( dataObj['controlFrequency'] )), 1)
                                        ]))
                                      : (column == 'controlPriority')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(dataObj[column])])
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(_ctx.colorLabelText(dataObj[column]))
                                              }, _toDisplayString(_ctx.getProirityLabel(dataObj[column])), 3)
                                            ], 2)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                            _createElementVNode("div", _hoisted_126, [
                                              _createElementVNode("p", {
                                                class: "fullText",
                                                onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, dataObj, 'text'))
                                              }, _toDisplayString(dataObj[column]), 41, _hoisted_127)
                                            ])
                                          ]))
                                  ], 40, _hoisted_122))
                                }), 128))
                              ]))
                            }), 128))
                          ]))
                    ])
                  ]),
                  (_ctx.sortedDataActiveControls.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                        _createVNode(_component_pagination, {
                          dynamicPagination: _ctx.dynamicPagination,
                          onCurrentPageUpdate: _ctx.paginationUpdations,
                          sortedData: _ctx.sortedDataActiveControls
                        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.toolTipActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.selectedTabIndex == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("table", null, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("th", _hoisted_133, [
                            _createElementVNode("div", _hoisted_134, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectAllOptionAllControls) = $event)),
                                class: "checkbox cursor-pointer",
                                disabled: _ctx.sortedDataAllControls.length == 0,
                                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.selectAllAllControls($event)))
                              }, null, 40, _hoisted_135), [
                                [_vModelCheckbox, _ctx.selectAllOptionAllControls]
                              ])
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (column) => {
                            return (_openBlock(), _createElementBlock("th", {
                              scope: "col",
                              onClick: ($event: any) => (_ctx.sort(column)),
                              class: _normalizeClass([_ctx.getHeaderProperties1('width',column), "bg-white capitalize"]),
                              key: column
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex items-center", _ctx.getHeaderProperties1('widthInner',column)])
                              }, [
                                (column == 'controlPriority')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, _toDisplayString('Priority')))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_ctx.getHeaderProperties1('name',column)), 1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                }, null, 2)
                              ], 2)
                            ], 10, _hoisted_136))
                          }), 128)),
                          (_ctx.showFilters)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_139, [
                                _hoisted_140,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (name, index) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    class: "bg-white",
                                    key: index
                                  }, [
                                    (name == 'controlPriority')
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 0,
                                          class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                        }, [
                                          _hoisted_142,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: pair,
                                              value: pair.value
                                            }, _toDisplayString(pair.key), 9, _hoisted_143))
                                          }), 128))
                                        ], 10, _hoisted_141)), [
                                          [_vModelSelect, _ctx.allFilters[name]]
                                        ])
                                      : (name == 'controlFrequency')
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 1,
                                            class: _normalizeClass(["widthForSelect", _ctx.allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                          }, [
                                            _hoisted_145,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: pair,
                                                value: pair.value
                                              }, _toDisplayString(pair.key), 9, _hoisted_146))
                                            }), 128))
                                          ], 10, _hoisted_144)), [
                                            [_vModelSelect, _ctx.allFilters[name]]
                                          ])
                                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 2,
                                            type: "text",
                                            class: "searchForInputBoxStyling filter-font-size",
                                            placeholder: "Search",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.allFilters[name]) = $event)
                                          }, null, 8, _hoisted_147)), [
                                            [_vModelText, _ctx.allFilters[name]]
                                          ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.sortedDataAllControls.length == 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_148, [
                              _createElementVNode("tr", _hoisted_149, [
                                _createElementVNode("td", {
                                  class: "relative h-10",
                                  colspan: _ctx.allControlHeaders.length + 1
                                }, _hoisted_152, 8, _hoisted_150)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_153, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDataAllControls, (controlObject, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: index,
                                  class: "cursor-pointer rowHeight"
                                }, [
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "checkbox mx-2",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.checkedAllControls) = $event)),
                                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.changedAllControlInput())),
                                      value: controlObject._id
                                    }, null, 40, _hoisted_154), [
                                      [_vModelCheckbox, _ctx.checkedAllControls]
                                    ])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlHeaders, (column) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      scope: "col",
                                      onMouseout: _cache[27] || (_cache[27] = ($event: any) => (_ctx.doFalse())),
                                      key: column
                                    }, [
                                      (column == 'controlFrequency')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.getFrequencyValue( controlObject[column] )), 1)
                                          ]))
                                        : (column == 'controlPriority')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(controlObject[column])])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(_ctx.colorLabelText(controlObject[column]))
                                                }, _toDisplayString(_ctx.getProirityLabel(controlObject[column])), 3)
                                              ], 2)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                              _createElementVNode("div", _hoisted_158, [
                                                _createElementVNode("p", {
                                                  class: "fullText",
                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, controlObject, 'text'))
                                                }, _toDisplayString(controlObject[column]), 41, _hoisted_159)
                                              ])
                                            ]))
                                    ], 32))
                                  }), 128))
                                ]))
                              }), 128))
                            ]))
                      ])
                    ]),
                    (_ctx.sortedDataAllControls.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                          _createVNode(_component_pagination, {
                            dynamicPagination: _ctx.dynamicPagination,
                            onCurrentPageUpdate: _ctx.paginationUpdations,
                            sortedData: _ctx.sortedDataAllControls
                          }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.toolTipActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                        _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.selectedTabIndex == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("button", {
                disabled: _ctx.clickOnButton,
                class: _normalizeClass([JSON.stringify(_ctx.mainSystem) == JSON.stringify(_ctx.dummySystem) ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onCancelbtn('cancel')))
              }, "Cancel", 10, _hoisted_164),
              _createElementVNode("button", {
                disabled: _ctx.clickOnButton,
                class: _normalizeClass([JSON.stringify(_ctx.mainSystem) == JSON.stringify(_ctx.dummySystem) ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary"]),
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.editSystem('update')))
              }, "Save", 10, _hoisted_165)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedTabIndex == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
            _createElementVNode("div", _hoisted_167, [
              _createElementVNode("button", {
                class: _normalizeClass(["btnprimary mr-1.5", _ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary']),
                disabled: _ctx.clickOnButton,
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.cancelActiveControls()))
              }, "Cancel", 10, _hoisted_168),
              _createElementVNode("button", {
                class: _normalizeClass(["btnprimary", _ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary']),
                disabled: _ctx.clickOnButton,
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.changeActiveControlsToActivity(10303)))
              }, "Save", 10, _hoisted_169)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedTabIndex == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
            _createElementVNode("div", _hoisted_171, [
              _createElementVNode("button", {
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCancelAllControls())),
                disabled: _ctx.clickOnButton,
                class: _normalizeClass([_ctx.checkedAllControls.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary mr-1.5"])
              }, "Cancel", 10, _hoisted_172),
              _createElementVNode("button", {
                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.mapTheSelectedControlsToActivity(10301))),
                disabled: _ctx.clickOnButton,
                class: _normalizeClass([_ctx.checkedAllControls.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"])
              }, "Save", 10, _hoisted_173)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}